import { createContext, useContext } from "react";
import { previewWorkspaceFile, workspaceContentUrl, workspaceDownloadUrl } from "./api";

/** 文件展示只依赖窄接口；公开案例不会借用私有会话 API。 */
export const WorkspaceFileAccessContext = createContext({
  downloadUrl: workspaceDownloadUrl,
  contentUrl: workspaceContentUrl,
  preview: previewWorkspaceFile,
});
export const useWorkspaceFileAccess = () => useContext(WorkspaceFileAccessContext);
